// extracted by mini-css-extract-plugin
export default {"wrapper":"content-wrapper_wrapper__dHv8J"};